import React from 'react';
import { useTranslation } from 'react-i18next';
const COLLECTIONS = ['men', 'women', 'children'];
const COLLECTIONSCODES = ['01', '02', '03'];
const StoreBoutiqueCollections = (props) => {
    const { t } = useTranslation();
    const { collections } = props;
    if (!collections) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "store__moreinfo__section" },
        React.createElement("h2", { className: "store__moreinfo__section__title" }, t('store.collectionsinboutique')),
        React.createElement("ul", { className: "boutique-collections" }, collections.split(' ').map((collection, i) => {
            if (COLLECTIONSCODES.indexOf(collection) != -1) {
                return React.createElement("li", { key: i }, t(`storelocator.${COLLECTIONS[COLLECTIONSCODES.indexOf(collection)]}`));
            }
            else {
                // fallback
                return React.createElement("li", { key: i }, collection);
            }
        }))));
};
export default StoreBoutiqueCollections;
